import { render, staticRenderFns } from "./svipServiceAgreement.vue?vue&type=template&id=478cfe84&scoped=true&"
import script from "./svipServiceAgreement.vue?vue&type=script&lang=js&"
export * from "./svipServiceAgreement.vue?vue&type=script&lang=js&"
import style0 from "./svipServiceAgreement.vue?vue&type=style&index=0&id=478cfe84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478cfe84",
  null
  
)

export default component.exports